enum FarmerOrderRoutes {
  List = '/farmer-orders',
  Edit = '/farmer-orders/edit/:id',
  Add = '/farmer-orders/add',
}

export default FarmerOrderRoutes
